import React from 'react';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';

const Returns = () => {
  return (
      <React.Fragment>

     <h2 className="pt-5">Returns</h2>
    <MDBTable bordered>
      <MDBTableHead>
        <tr>
          <th>Transaction Date</th>
          <th>Customer</th>
          <th>Item / Description</th>
         
        
          <th>Cash</th>
          <th>Quantity (kilograms)</th>
          <th>Unit Cost</th>
          <th>Total Cost</th>
         
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        <tr>  
          <td>Feb 2, 2021 09:00 AM</td>
          <td>Liza</td>
          <td>Bean Sprout</td>
          <td>Yes</td>
          <td>5</td>
          <td>Php 70.00</td>
          <td>Php 350.00</td>
        </tr>
        <tr>  
          <td>Feb 2, 2021 09:15 AM</td>
          <td>Angelo</td>
          <td>Bean Sprout</td>
          <td>Yes</td>
          <td>3</td>
          <td>Php 70.00</td>
          <td>Php 210.00</td>
        </tr>
        <tr>  
          <td>Feb 2, 2021 09:45 AM</td>
          <td>Eli</td>
          <td>Bean Sprout</td>
          <td>Yes</td>
          <td>5</td>
          <td>Php 70.00</td>
          <td>Php 350.00</td>
        </tr>
        <tr>  
          <td>Feb 2, 2021 09:55 AM</td>
          <td>Dean</td>
          <td>Bean Sprout</td>
          <td>Yes</td>
          <td>4</td>
          <td>Php 70.00</td>
          <td>Php 280.00</td>
        </tr>
      </MDBTableBody>
    </MDBTable>
    </React.Fragment>
  );
}

export default Returns;